module.exports = __webpack_public_path__ + "static/media/bg2@2x.6fb3957b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/bg2@2x.png
// module id = 1186
// module chunks = 0